import {recommendFieldsType} from '../features/recommendations/CreateRecommend/recommendFields';
import {OVRecommendActionEnum} from '../schema-types/globalTypes';

export const RECOMMENDATION_SUBTYPE_TO_SERVER = {
  PRODUCT_BASED: 'Product based',
  ACTION_BASED: 'Action based',
  INSTRUCTION: 'Service', // Curo changed from 'Execution Only'
};

export const RECOMMENDATION_TYPES = {
  Recommendation: 'Recommendation',
  Instruction: 'Instruction',
};

export const SPP_RECOMMENDATION_TYPES = {
  ExecutionOnly: 'Execution Only',
  Advised: 'Advised',
};

export const serverToRecommendationTypeLabel = (val?: null | string) => {
  if (val === RECOMMENDATION_SUBTYPE_TO_SERVER.ACTION_BASED) {
    return RECOMMENDATION_TYPES.Recommendation;
  }
  if (val === RECOMMENDATION_SUBTYPE_TO_SERVER.PRODUCT_BASED) {
    return RECOMMENDATION_TYPES.Recommendation;
  }
  if (val === RECOMMENDATION_SUBTYPE_TO_SERVER.INSTRUCTION) {
    return RECOMMENDATION_TYPES.Instruction;
  }
};

export const recommendationFormToServerType = (values: recommendFieldsType) => {
  if (
    values.planAction === OVRecommendActionEnum.ACTION ||
    values.planAction === OVRecommendActionEnum.AD_HOC_FEE
  ) {
    return RECOMMENDATION_SUBTYPE_TO_SERVER.ACTION_BASED;
  }
  return RECOMMENDATION_SUBTYPE_TO_SERVER.PRODUCT_BASED;
};
